<template>
  <div>
     <head-public title="校派"></head-public>
      <div class="main">
  <div class="item" v-for="(item,index) in list" :key="index">
    <div class="back-img">
      <img :src="item.backimg" />
    </div>
    <div class="title">{{item.name}}</div>
    <div class="tips">{{item.description}}</div>
    <div class="price">
      <div class="feee">￥{{item.fee}}服务费</div>
      <div class="consult">
        <div class="_person">{{item.ask}}人咨询</div>
        <div class="line"></div>
        <div class="button">咨询</div>
      </div>
    </div>

  </div>
</div>
  </div>
</template>

<script>
import {httpPost} from "../../axios/index";
import headPublic from "../../components/publicHead"
export default {
    data(){
        return{
            list:[]
        }
    },
    methods: {
        // 获取数据
        fetchData(){
            httpPost("/abroad/direction",{
                id:this.$route.query.id
            }).then(res=>{
                if(res.code==1){
                    this.list=res.data;
                }
            })
        }
    },
    mounted () {
        this.fetchData();
    },
   components:{
    headPublic
    }
}
</script>

<style scoped>
    .main{
        margin-top: 56px;
    }
    .item {
    width: 95vw;
    margin: 0 auto;
    box-shadow: 0px 0px 0.625rem #ccc;
    font-size: 1rem;
    border-radius: 0.3125rem;
    position: relative;
    margin-top: 1.25rem;
    box-sizing:border-box;

}

image {
    width: 100%;
    height: 100%;
}

.back-img {
    height: 9.375rem;
    box-sizing: border-box
}
.back-img img{
   width: 100%;
}

.title {
    padding: 1.5625rem 0.625rem 0.3125rem;
    color: #383838;
}

.tips {
    color: #888;
    padding-left: 0.625rem;
}

.price {
    padding: 1.25rem 0.625rem;
    font-size: 1.25rem;
    color: #ff6d6d;
}
._person{
    line-height: 2.5rem;
}
.consult {
    display: flex;
    position: absolute;
    bottom: 0.625rem;
    right: 0.625rem;
    background: #22d9d9;
    color: #fff;
    padding: 0 0.8125rem;
    border-radius: 1.5625rem;
    font-size: 0.75rem;
}

.line {
    width: 0.0625rem;
    border-right: 0.0625rem #fff solid;
    margin: 0.8125rem 0.625rem;
}

.button {
    font-size: 1rem;
    width: 2.1875rem;
    line-height: 2.5rem;
}
.noPost{
  margin-top:  0.625rem;
  text-align: center;
}

</style>